import { Auth } from "components/Parts/Organisms/Auth";
import { SearchPage } from "components/Parts/Organisms/SearchPage";
import { SearchProps } from "components/Parts/Organisms/SearchPage/interfaces";
import React from "react";
import { Navigate } from "react-router";

export const Search = React.memo((props: SearchProps) => {
  if (
    !document.referrer.includes("sumora.jp") &&
    !document.referrer.includes("amplifyapp.com") &&
    !document.referrer.includes("localhost:20006")
  ) {
    Navigate({ to: "/" });
  }

  return (
    <Auth>
      <SearchPage {...props} />
    </Auth>
  );
});
